import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SideNav from "./SideNav";
import Dashboard from "./dashboard/Dashboard";

import Countries from "./features/Settings/Countries";
import Cities from "./features/Settings/Cities";
import Families from "./features/Settings/Families";
import SubFamilies from "./features/Settings/SubFamilies";
import Brand from "./features/Settings/Brand";
import UnitOfMeasurement from "./features/Settings/UnitOfMeasurement";
import TypesFournisseurs from "./features/Settings/TypesFournisseurs";
import TypesClients from "./features/Settings/TypesClients";

import RoleManagement from "./features/Users/RoleManagement";
import UserManagement from "./features/Users/UserManagement";
import Suppliers from "./features/Suppliers/Suppliers";
import Clients from "./features/Clients/Clients";
import Articles from "./features/Articles/Articles";
import Devis from "./features/Documents/Devis";
import BonCommandeVente from "./features/Documents/BonCommandeVente";
import BonLivraison from "./features/Documents/BonLivraison";
import BonRetourVente from "./features/Documents/BonRetourVente";
import Facture from "./features/Documents/Facture";
import BonCommandeAchat from "./features/Documents/BonCommandeAchat";
import BonReception from "./features/Documents/BonReception";
import DemandeAchat from "./features/Documents/DemandeAchat";
import FactureAchat from "./features/Documents/FactureAchat";
import BonRetourAchat from "./features/Documents/BonRetourAchat";
import Folders from "./features/Ged/Folders";
import Documents from "./features/Ged/Documents";

import Depot from "./features/Depots/Depot";

import DocumentTransfertAchatPage from "./features/Documents/Transfert/DocumentTransfertAchatPage";
import DocumentTransfertVentePage from "./features/Documents/Transfert/DocumentTransfertVentePage";
import PaymentModes from "./features/Settings/PaymentModes";
import Payments from "./features/Payments/Payments";
import PaymentsAchat from "./features/Payments/PaymentsAchat";
import PaymentsVente from "./features/Payments/PaymentsVente";
import RelevesAchat from "./features/Releves/RelevesAchat";
import RelevesVente from "./features/Releves/RelevesVente";
import ChangePassword from "./authentication/ChangePassword";
import Projets from "./features/GestionProjets/Projets";
import DashboardProjets from "./features/GestionProjets/DashboardProjets";
import ProjetsList from "./features/GestionProjets/ProjetsList";
import ProjetDetail from "./features/GestionProjets/ProjetDetail";
import Employes from "./features/GestionProjets/Employes";
import TachesPlanning from "./features/GestionProjets/TachesPlanning";
   import RapportsProjets from "./features/GestionProjets/RapportsProjets";
 import DashboardArchives from "./features/Ged/DashboardArchives";
import RelevesDetaillesAchat from "./features/Releves/RelevesDetaillesAchat";
import RelevesDetaillesVente from "./features/Releves/RelevesDetaillesVente";

function Content({ onLogout }) {
    return (
        <div className="wrapper">
            <Header onLogout={onLogout} /> {/* Passe onLogout au Header */}
            <SideNav />
            <div className="content-wrapper" style={{ padding: "20px" }}>
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    {/* <Route path="/accueil" element={<Dashboard />} /> */}
                    {/* Paramètres */}
                    <Route path="/pays" element={<Countries />} />
                    <Route path="/villes" element={<Cities />} />
                    <Route path="/depots" element={<Depot />} />
                    <Route path="/familles-articles" element={<Families />} />
                    <Route path="/sub-familles-articles" element={<SubFamilies />} />
                    <Route path="/marques" element={<Brand />} />
                    <Route path="/unites" element={<UnitOfMeasurement />} />
                    <Route path="/types-fournisseurs" element={<TypesFournisseurs />} />
                    <Route path="/types-clients" element={<TypesClients />} />
                    <Route path="/payment-modes" element={<PaymentModes />} />
                    <Route path="/changePassword" element={<ChangePassword />} />
                    <Route path="/archives/projets" element={<Projets />} />
                    {/* Utilisateurs & Rôles */}
                    <Route path="/roles" element={<RoleManagement />} />
                    <Route path="/users" element={<UserManagement />} />

                    {/* Clients & Suppliers */}
                    <Route path="/fournisseurs" element={<Suppliers />} />
                    <Route path="/clients" element={<Clients />} />

                    {/* Articles */}
                    <Route path="/articles" element={<Articles />} />

                    {/* Devis */}
                    {/* <Route path="/achats-devis" element={<Devis />} /> */}

                    {/* Documents Vente */}
                    <Route path="/ventes-devis" element={<Devis />} />
                    <Route path="/ventes-bons-commande" element={<BonCommandeVente />} />
                    <Route path="/ventes-bons-livraison" element={<BonLivraison />} />
                    <Route path="/ventes-bons-retour" element={<BonRetourVente />} />
                    <Route path="/ventes-factures" element={<Facture />} />
                    <Route path="/ventes-transfert" element={<DocumentTransfertVentePage />} />
                    <Route path="/ventes-payments" element={<PaymentsVente />} />
                    <Route path="/ventes-releves" element={<RelevesVente />} />
                    <Route path="/ventes-releves-detail" element={<RelevesDetaillesVente />} />
                    {/* Documents Achat */}
                    <Route path="/achats-devis" element={<DemandeAchat />} />
                    <Route path="/achats-bons-commande" element={<BonCommandeAchat />} />
                    <Route path="/achats-bons-livraison" element={<BonReception />} />
                    <Route path="/achats-bons-retour" element={<BonRetourAchat />} />
                    <Route path="/achats-factures" element={<FactureAchat />} />
                    <Route path="/achats-transfert" element={<DocumentTransfertAchatPage />} />
                    <Route path="/achats-payments" element={<PaymentsAchat />} />
                    <Route path="/achats-releves" element={<RelevesAchat />} />
                    <Route path="/achats-releves-detail" element={<RelevesDetaillesAchat />} />
                    <Route path="/archives" element={<Folders />} />
                    <Route path="/archives/documents" element={<Documents />} />
                    <Route path="/archives/corbeille" element={<Documents defaultStatus="deleted" />} />
                    <Route path="/projets" element={<DashboardProjets />} />
                    <Route path="/projets/liste" element={<ProjetsList />} />
                    <Route path="/projets/fiche/:id" element={<ProjetDetail />} />
                    <Route path="/projets/employes" element={<Employes />} />
                    <Route path="/projets" element={<DashboardProjets />} />
                    <Route path="/projets/taches" element={<TachesPlanning />} />
                   <Route path="/projets/RapportsProjets" element={<RapportsProjets />} />
                    {/* Par défaut */}
                    <Route path="*" element={<Navigate to="/" />} />
                     <Route path="/archives/dashboard" element={<DashboardArchives />} />
                </Routes>
            </div>
            <Footer />
        </div>
    );
}

export default Content;